import {ReactComponent} from "./ic_user_fill.svg";

interface UserFillIconProps {
    color?: string;
    size?: number;
}

const UserFillIcon: React.FC<UserFillIconProps> = (
    {
        color = '#09121F',
        size = 24,
    }
) => <ReactComponent
    style={{fill: color, width: size, height: size}}
/>;

export default UserFillIcon;
